import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Carousel, Image } from "react-bootstrap";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { useAlert } from "../../../../Context/AlertModalContext";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import styles from "./paymentNew.module.css";

import PaymentCheckout from "./PaymentCheckout";
import PaymentPromo from "./PaymentPromo";

import logo from "../../../../assets/images/MTDlogo.png";
import carouselOne from "../../../../assets/images/crau1.png";
import carouselTwo from "../../../../assets/images/crau2.png";
import carouselThree from "../../../../assets/images/crau3.png";

import mobileCarouselOne from "../../../../assets/images/couple/billing/couple-1-responsive.jpg";
import mobileCrousletwo from "../../../../assets/images/couple/billing/couple-2-responsive.jpg";
import mobileCrouslethree from "../../../../assets/images/couple/billing/couple-3-responsive.jpg";

import Loader from "../../../Utility/Loader";
import { useCookies } from "../../../../hooks/useCookies";
import { useSocket } from "../../../../Context/SockerContext";
import { useAppContext } from "../../../../Context/UseContext";
import Sidebar from "../../../userflow/components/sidebar/sidebar";
import * as BillingAction from "../../../../actions/BillingHistory";
import * as paymentActions from "../../../../actions/payment";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const PaymentNew = () => {
  const alert = useAlert();
  const navigate = useNavigate();

  const { getCookie } = useCookies();
  const userId = getCookie("userId");

  const [clientSecret, setClientSecret] = useState("");

  const rates = ["CAD", "USD", "GBP", "EUR", "AUD"];
  const currencySymbols = {
    CAD: "CAD",
    USD: "$",
    GBP: "£",
    EUR: "€",
    AUD: "AUD",
  };
  const currencyRates = { CAD: 1, USD: 0.73, GBP: 0.56, EUR: 0.66, AUD: 1.08 };

  const [selectedCurrency, setSelectedCurrency] = useState("CAD");
  const [selectedCard, setSelectedCard] = useState(2);
  const { updateSubscriptionStatus, setIsPremium } = useAppContext();
  const cookies = useCookies();

  const basePricePlans = [
    {
      id: 0,
      duration: "1 month",
      monthly: 49.99,
      priceId: process.env.REACT_APP_STRIPE_PRICE_ID_1_MONTHS,
      productId: process.env.REACT_APP_STRIPE_PRODUCT_ID_1_MONTHS,
    },
    {
      id: 1,
      isPopular: true,
      savings: "Save 50%",
      duration: "6 months",
      monthly: 24.99,
      total: 149.99,
      iconSVG: `<svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.22257 0.0442374C1.68697 0.0442374 2.06497 0.422237 2.06497 0.886637C2.06497 1.18784 1.90657 1.45904 1.64137 1.61264C1.51657 1.68464 1.47457 1.84424 1.54657 1.96904L4.38337 6.88184C4.43017 6.96224 4.51537 7.01264 4.60897 7.01264C4.70257 7.01264 4.78777 6.96344 4.83457 6.88184L7.67137 1.96784C7.74337 1.84304 7.70137 1.68464 7.57657 1.61264C7.31137 1.45904 7.15417 1.18784 7.15417 0.887838C7.15417 0.423438 7.53217 0.0454375 7.99657 0.0454375C8.46097 0.0454375 8.83897 0.423438 8.83897 0.887838C8.83897 1.18904 8.68058 1.46024 8.41418 1.61384C8.35417 1.64864 8.31098 1.70504 8.29298 1.77224C8.27498 1.83944 8.28457 1.91024 8.31937 1.97024L11.1586 6.88304C11.2054 6.96344 11.2906 7.01384 11.3842 7.01384C11.4778 7.01384 11.563 6.96464 11.6098 6.88304L14.4466 1.97024C14.5186 1.84544 14.4754 1.68584 14.3518 1.61384C14.0866 1.46024 13.9282 1.18904 13.9282 0.887838C13.9282 0.423438 14.3062 0.0454375 14.7706 0.0454375C15.235 0.0454375 15.613 0.423438 15.613 0.887838C15.613 1.35224 15.235 1.73024 14.7706 1.73024C14.6266 1.73024 14.5102 1.84664 14.5102 1.99064V9.43544H8.66857C8.52457 9.43544 8.40817 9.55184 8.40817 9.69584C8.40817 9.83984 8.52457 9.95624 8.66857 9.95624H14.5102V11.9578H1.48417V1.98944C1.48417 1.84544 1.36777 1.72904 1.22378 1.72904C0.759375 1.72904 0.381375 1.35104 0.381375 0.886637C0.381375 0.422237 0.758175 0.0442374 1.22257 0.0442374Z" fill="#FC8C66"/></svg>`,
      priceId: process.env.REACT_APP_STRIPE_PRICE_ID_6_MONTHS,
      productId: process.env.REACT_APP_STRIPE_PRODUCT_ID_6_MONTHS,
    },
    {
      id: 2,
      savings: "Save 33%",
      duration: "3 months",
      monthly: 33.99,
      total: 99.99,
      priceId: process.env.REACT_APP_STRIPE_PRICE_ID_3_MONTHS,
      productId: process.env.REACT_APP_STRIPE_PRODUCT_ID_3_MONTHS,
    },
  ];

  const [pricePlans, setPricePlans] = useState(basePricePlans);
  const [priceId, setPriceId] = useState(pricePlans[2].priceId);
  const [product, setProduct] = useState(pricePlans[2].productId);

  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

  const [validCoupon, setValidCoupon] = useState(null);

  const [paymentLoader, setPaymentLoader] = useState(false);
  const [paymentSectionShow, setPaymentSectionShow] = useState(false);
  const { socket } = useSocket();
  const [mobile, setMobile] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false);


  useEffect(() => {
    if (window.innerWidth < 575) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  const handlePaymentSucceeded = async () => {
    setIsPremium(true);
    cookies.setCookie("isPremium", true);
    await updateSubscriptionStatus();
    setTimeout(() => {
      navigate("/user/home");
      alert.setModal({
        show: true,
        message: "Payment Successfully Completed.",
        title: "Success",
      });
    }, 1000);
    setPaymentLoader(false);
  };

  useEffect(() => {
    if (!socket) return;
    socket.on("payment_succeeded", data => {
      setPaymentLoader(true);
      if (Number(data?.userId) === Number(userId)) {
        handlePaymentSucceeded();
      } else {
        setPaymentLoader(false);
      }
    });
  }, [socket]);

const initializePayment = useCallback(async () => {
  if (!paymentSectionShow) return;

  try {
    setPaymentLoader(true);

    const data = await paymentActions.createSubscriptionsPaymentIntent(
      JSON.stringify({
        currency: selectedCurrency,
        priceId,
        paymentMethodId: selectedPaymentMethod,
        coupon: validCoupon ? validCoupon.id : null,
      })
    );

    if (data?.paymentIntentStatus === "succeeded") {
      // Handled elsewhere via socket or effect
    } else {
      setClientSecret(data.client_secret);
    }
  } catch (error) {
    alert.setModal({
      show: true,
       message:
        error.message ||
        error.response?.data?.message ||
        "Something went wrong. Please try again.",
      title: "Error",
      onButtonClick: () => {
        window.location.reload();
      },
    });
  } finally {
    // setPaymentLoader(false);
    setHasInitialized(true);
    setTimeout(() => {
       setPaymentLoader(false);
    }, 5000);
  }
}, [
  alert,
  paymentSectionShow,
  selectedCurrency,
  priceId,
  selectedPaymentMethod,
  validCoupon,
]);


  const fetchPaymentMethods = async () => {
    const paymentMethods = await BillingAction.getPaymentMethods();
    setPaymentMethods(paymentMethods || []);
  };

  useEffect(() => {
    paymentActions.checkStripeAccount();
    fetchPaymentMethods();
  }, []);

  useEffect(() => {
    if(!hasInitialized){
    initializePayment();
    }
  }, [paymentSectionShow, initializePayment,hasInitialized]);

  const handleCurrencyChange = async event => {
    setPaymentLoader(true);
    const newCurrency = event.target.value;
    setSelectedCurrency(newCurrency);

    // Convert prices to the selected currency
    const newPrices = basePricePlans.map(plan => ({
      ...plan,
      monthly: (plan.monthly * currencyRates[newCurrency]).toFixed(2),
      total: plan.total
        ? (plan.total * currencyRates[newCurrency]).toFixed(2)
        : undefined,
    }));

    setPricePlans(newPrices);
    setPaymentLoader(false);
  };

  const handleCardClick = async (planKey, index) => {
    setSelectedCard(index);
    setPriceId(planKey.priceId);
    setProduct(planKey.productId);

    // Reset coupon
    resetPaymentValues();
  };

  const resetPaymentValues = () => {
    setValidCoupon(null);

    setClientSecret("");
    setPaymentSectionShow(false);
  };

  const handlePaymentSuccess = async (paymentIntent, billingAddress) => {
    setPaymentLoader(true);
    try {
      await paymentActions.paymentIntentConfirmation(
        JSON.stringify({
          priceId: priceId,
          coupon: validCoupon?.id,
          paymentIntentId: paymentIntent.id,
          billingAddress,
        })
      );
      setIsPremium(true);
      cookies.setCookie("isPremium", true); // Optional — if you want immediate cookie
      await updateSubscriptionStatus(); // 👈 Call from context
      alert.setModal({
        show: true,
        message: "Payment Successfully Completed.",
        title: "Success",
      });
      setTimeout(() => {
        navigate("/user/home");
      }, 1000);
    } catch (error) {
      alert.setModal({
        show: true,
        message: error.message || "Something went wrong. Please try again.",
        title: "Error",
      });
    }finally{
    setPaymentLoader(false);

    }
  };

  const handlePaymentError = error => {
    console.error("Payment error:", error);
  };

  const stripeOptions = { clientSecret, appearance: { theme: "stripe" } };

  return (
    <Sidebar>
      {paymentLoader && <Loader />}
      <div className="container-fluid">
        <div className="row pt-3">
          {/* Sidebar Carousel */}
          <div className={styles.logo}>
            <img src={logo} alt="" width={150} height={50} />
          </div>
          <div
            className={`col-xl-3 col-lg-5 col-md-5 col-sm-5 col-12 mb-3 payment-couple-carousel ${styles.paymentCoupleCarousel}`}
          >
            <Carousel pause="hover" indicators={true} controls={false}>
              {[
                {
                  mobileImg: mobileCarouselOne,
                  webImg: carouselOne,
                  benefits: [
                    "Send & receive unlimited messages",
                    "See who liked you",
                  ],
                },
                {
                  mobileImg: mobileCrousletwo,
                  webImg: carouselTwo,
                  benefits: [
                    "Access all premium filters to help you find exact matches",
                  ],
                },
                {
                  mobileImg: mobileCrouslethree,
                  webImg: carouselThree,
                  benefits: [
                    "Access special events & dating support"
                  ],
                },
              ].map((item, index) => (
                <Carousel.Item key={index}>
                  {/* Mobile: Show text ABOVE image */}
                  <div className="d-block d-sm-none mb-2">
                    <h5 className={styles.mobileTitle}>Premium Membership</h5>
                    <ul>
                      {item.benefits.map((benefit, idx) => (
                        <li key={idx}>{benefit}</li>
                      ))}
                    </ul>
                  </div>

                  <div>
                    {/* Image for Mobile */}
                    <Image
                      src={item.mobileImg}
                      className={`${styles.carouselImageMobile} d-block w-100 d-sm-none`}
                    />

                    {/* Image for Web */}
                    <Image
                      src={item.webImg}
                      className={`${styles.carouselImageWeb} d-none d-sm-block`}
                    />
                  </div>

                  {/* Web: Show text inside image */}
                  <Carousel.Caption
                    className={`${styles.carouselCaption} d-none d-sm-block`}
                  >
                    <h5>Premium Membership Benefits</h5>
                    <ul>
                      {item.benefits.map((benefit, idx) => (
                        <li key={idx}>{benefit}</li>
                      ))}
                    </ul>
                  </Carousel.Caption>
                </Carousel.Item>
              ))}
            </Carousel>
          </div>

          <div className="col-xl-9 col-lg-7 col-md-7 col-sm-7 col-12 p-4 mt-4">
            {/* Plan Price Cards */}
            <div className={`row g-4 g-xl-6 ${styles.paymentPlanSection}`}>
              {pricePlans.map((plan, idx) => (
                <div key={plan.id} className="col-4">
                  <div
                    className={`${styles.priceCard} ${selectedCard === plan.id ? styles.isSelectedCard : ""
                      }`}
                    onClick={() => handleCardClick(plan, idx)}
                  >
                    <div className={styles.cardBody}>
                      {plan.isPopular && (
                        <p className={styles.isPopularPlan}>Most Popular</p>
                      )}
                      {plan.isPopular && mobile && (
                        <span className="pe-2">
                          <svg
                            width="24"
                            height="18"
                            viewBox="0 0 24 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.84167 0.0624499C2.53827 0.0624499 3.10527 0.629449 3.10527 1.32605C3.10527 1.77785 2.86767 2.18465 2.46987 2.41505C2.28267 2.52305 2.21967 2.76245 2.32767 2.94965L6.58287 10.3189C6.65307 10.4395 6.78087 10.5151 6.92127 10.5151C7.06167 10.5151 7.18947 10.4413 7.25967 10.3189L11.5149 2.94785C11.6229 2.76065 11.5599 2.52305 11.3727 2.41505C10.9749 2.18465 10.7391 1.77785 10.7391 1.32785C10.7391 0.63125 11.3061 0.06425 12.0027 0.06425C12.6993 0.06425 13.2663 0.63125 13.2663 1.32785C13.2663 1.77965 13.0287 2.18645 12.6291 2.41685C12.5391 2.46905 12.4743 2.55365 12.4473 2.65445C12.4203 2.75525 12.4347 2.86145 12.4869 2.95145L16.7457 10.3207C16.8159 10.4412 16.9437 10.5169 17.0841 10.5169C17.2245 10.5169 17.3523 10.4431 17.4225 10.3207L21.6777 2.95145C21.7857 2.76425 21.7209 2.52485 21.5355 2.41685C21.1377 2.18645 20.9001 1.77965 20.9001 1.32785C20.9001 0.63125 21.4671 0.06425 22.1637 0.06425C22.8603 0.06425 23.4273 0.63125 23.4273 1.32785C23.4273 2.02445 22.8603 2.59145 22.1637 2.59145C21.9477 2.59145 21.7731 2.76605 21.7731 2.98205V14.1493H13.0107C12.7947 14.1493 12.6201 14.3239 12.6201 14.5399C12.6201 14.7559 12.7947 14.9304 13.0107 14.9304H21.7731V17.9328H2.23407V2.98025C2.23407 2.76425 2.05947 2.58965 1.84348 2.58965C1.14688 2.58965 0.579875 2.02265 0.579875 1.32605C0.579875 0.629449 1.14507 0.0624499 1.84167 0.0624499Z"
                              fill="#F97972"
                            />
                          </svg>
                        </span>
                      )}
                      <h5
                        className={`${window.innerWidth < 576 ? "" : "mt-4"} ${styles.cardTitle
                          }`}
                      >
                        {plan.duration}
                      </h5>
                      <h2 className={styles.cardPrice}>
                        {currencySymbols[selectedCurrency]}
                        {plan.monthly}
                        {plan.id !== 0 && (
                          <span className={styles.perMonth}>/mo</span>
                        )}
                      </h2>
                      {plan.savings && (
                        <p className={styles.cardSavingText}>
                          <span className={styles.savePercentage}>
                            {plan.savings}
                          </span>
                        </p>
                      )}
                      {plan.total && (
                        <p className={styles.subTotal}>({plan.total} total)</p>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Plan Price Detail */}
            <div className={`plan-price-detail ${styles.paymentPlanPrice}`}>
              <div className={styles.selectedplandetails}>
                <div className={styles.mobile_hide}>
                  <p className={styles.premiumAccountUpgrade}>
                    <span className="pe-2">
                      <svg
                        width="24"
                        height="18"
                        viewBox="0 0 24 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.84167 0.0624499C2.53827 0.0624499 3.10527 0.629449 3.10527 1.32605C3.10527 1.77785 2.86767 2.18465 2.46987 2.41505C2.28267 2.52305 2.21967 2.76245 2.32767 2.94965L6.58287 10.3189C6.65307 10.4395 6.78087 10.5151 6.92127 10.5151C7.06167 10.5151 7.18947 10.4413 7.25967 10.3189L11.5149 2.94785C11.6229 2.76065 11.5599 2.52305 11.3727 2.41505C10.9749 2.18465 10.7391 1.77785 10.7391 1.32785C10.7391 0.63125 11.3061 0.06425 12.0027 0.06425C12.6993 0.06425 13.2663 0.63125 13.2663 1.32785C13.2663 1.77965 13.0287 2.18645 12.6291 2.41685C12.5391 2.46905 12.4743 2.55365 12.4473 2.65445C12.4203 2.75525 12.4347 2.86145 12.4869 2.95145L16.7457 10.3207C16.8159 10.4412 16.9437 10.5169 17.0841 10.5169C17.2245 10.5169 17.3523 10.4431 17.4225 10.3207L21.6777 2.95145C21.7857 2.76425 21.7209 2.52485 21.5355 2.41685C21.1377 2.18645 20.9001 1.77965 20.9001 1.32785C20.9001 0.63125 21.4671 0.06425 22.1637 0.06425C22.8603 0.06425 23.4273 0.63125 23.4273 1.32785C23.4273 2.02445 22.8603 2.59145 22.1637 2.59145C21.9477 2.59145 21.7731 2.76605 21.7731 2.98205V14.1493H13.0107C12.7947 14.1493 12.6201 14.3239 12.6201 14.5399C12.6201 14.7559 12.7947 14.9304 13.0107 14.9304H21.7731V17.9328H2.23407V2.98025C2.23407 2.76425 2.05947 2.58965 1.84348 2.58965C1.14688 2.58965 0.579875 2.02265 0.579875 1.32605C0.579875 0.629449 1.14507 0.0624499 1.84167 0.0624499Z"
                          fill="#F97972"
                        />
                      </svg>
                    </span>
                    Premium Account Upgrade ({pricePlans[selectedCard].duration}
                    )
                  </p>
                  <div className="mt-2">
                    <p>
                      Subtotal: {currencySymbols[selectedCurrency]}{" "}
                      {pricePlans[selectedCard].total ||
                        pricePlans[selectedCard].monthly}{" "}
                      {selectedCurrency}
                    </p>
                    <p className={styles.total}>
                      Total: {currencySymbols[selectedCurrency]}{" "}
                      {pricePlans[selectedCard].total ||
                        pricePlans[selectedCard].monthly}{" "}
                      {selectedCurrency}
                    </p>
                  </div>
                </div>
                <div className={styles.mobile_show}>
                  <div className={styles.currencyselected}>
                    <div className={styles.selectWrapper}>
                      <select
                        name="currency"
                        id="currency-select"
                        className={`form-select ${styles.formSelectCurrency}`}
                        value={selectedCurrency}
                        onChange={handleCurrencyChange}
                      >
                        {rates.map((rate, i) => (
                          <option key={i} value={rate}>
                            {rate}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Payment Section */}
            <div className={`payment-section ${styles.paymentSection}`}>
              {/* Payment Method Dropdown */}
              {paymentMethods?.length > 0 && (
                <div className="row">
                  <div className="col-12">
                    <label className="form-label h6">
                      Select Payment Method
                    </label>
                    <select
                      className="form-select mt-2"
                      value={selectedPaymentMethod || ""}
                      onChange={event =>
                        setSelectedPaymentMethod(event.target.value)
                      }
                    >
                      <option value="">Choose a payment method</option>
                      {paymentMethods.map(method => (
                        <option key={method.id} value={method.id}>
                          {method.card
                            ? `**** ${method.card.last4} - (${method.card.exp_month
                            }/${method.card.exp_year
                            }) - (${method.card.brand.toUpperCase()})`
                            : method.id}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              {/* Payment Intent */}
              {clientSecret ? (
                <div className={`pt-4`}>
                  <div>
                    <Elements stripe={stripePromise} options={stripeOptions}>
                      <PaymentCheckout
                        product={product}
                        priceId={priceId}
                        clientSecret={clientSecret}
                        validCoupon={validCoupon}
                        onSuccess={handlePaymentSuccess}
                        onError={handlePaymentError}
                        onResetPromocode={resetPaymentValues}
                        onPromoCodeValid={coupon => setValidCoupon(coupon)}
                      />
                    </Elements>
                  </div>
                </div>
              ) : (
                <div>
                  <PaymentPromo
                    product={product}
                    validCoupon={validCoupon}
                    onResetPromocode={resetPaymentValues}
                    onPromoCodeValid={coupon => setValidCoupon(coupon)}
                  />
                  <div className="hstack gap-2 justify-content-center">
                    <button
                      className="text-center global-next-btn mt-3"
                      disabled={paymentLoader}
                      onClick={() => setPaymentSectionShow(true)}
                    >
                      {paymentLoader ? "Processing..." : "Continue"}
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Sidebar>
  );
};

export default PaymentNew;
